import Icon from '../components/Icon.vue'

Icon.register({
  folder: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 128c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h160l64 64h192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/folder.js
// module id = 1366
// module chunks = 0